import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { UserGroupApi } from 'api';
import { SearchUserGroupQueryType } from 'types';

function useGetAll(query: SearchUserGroupQueryType) {
  return useAuthQuery(
    getQueryKeys([KEY]).list({ ...query }),
    () => UserGroupApi.getAll(query),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetAll;
